<script>
  import { onMount } from 'svelte';
  import textBalancer from './util/text-balancer';

  /**
   * Prop imports
   */
  // eslint-disable-next-line
  export let data;

  onMount(() => {
    textBalancer('.quote, .attribution');
  });
</script>

<style>
  .quote {
    font-size: 60px;
    line-height: 1.2em;
    padding:  10px 20px;
    background-color: #333;
    text-align: center;
    margin: auto;
  }

  .attribution {
    margin-top: 20px;
    line-height: 1.2em;
    float: right;
  }

  .page {
    padding: 150px 0;
    background-color: #333;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    /* scroll-snap-align: start; */
  }

  .quote-box {
    max-width: 800px;
    margin: auto;
    white-space: pre-wrap;
  }

  @media screen and (max-width: 600px) {
    .quote {
      font-size: 38px;
    }

    .quote-box {
      padding: 30px;
    }
  }
</style>

<div class="page" id="page1">
  <div class="quote-box">
    <div class="quote">{data.quote1}</div>
    <div class="attribution">{data.quote1attr}</div>
  </div>
</div>
